import { PropsWithChildren, useState } from "react";
import { FaCaretRight } from "react-icons/fa";
import { PiStarFourFill } from "react-icons/pi";

import { cn } from "@bentolabs/kit/utils";

import WasabiLogo from "shared/assets/wasabi-logo.svg?react";

import { DetailsDialog } from "../details-dialog/details-dialog";
import { DetailsWasabiContent } from "./details-wasabi-content";

type Props = {
  className?: string;
};

export const WasabiContent = (props: PropsWithChildren<Props>) => {
  const { className } = props;
  const [isFarmDialogOpen, setIsFarmDialogOpen] = useState(false);

  return (
    <div className="flex flex-col items-center text-white">
      <div
        className={cn(
          "text-spearmint max-auto mt-14.5 flex items-center gap-1.5",
          className
        )}
      >
        <PiStarFourFill
          style={{
            fill: "radial-gradient(51.15% 52.24% at 52.15% 50%, #11F5A5 0%, #1DC942 100%)",
          }}
        />

        <div>Boosted Points</div>
      </div>

      <div className="relative mt-3.5 flex items-center justify-center">
        <span className="text-nobel absolute bottom-2 -left-2 -translate-x-full leading-none">
          Up to
        </span>
        <div className="inline-flex text-7xl leading-none">10X</div>
      </div>

      <button
        className="mt-7 flex cursor-pointer items-center text-white/50 outline-hidden transition-colors hover:text-white/70"
        onClick={() => {
          setIsFarmDialogOpen(true);
        }}
      >
        More details
        <FaCaretRight className="ml-2 size-4" />
      </button>

      <DetailsDialog
        title="WASABI Points Farm"
        className="text-spearmint"
        img={<WasabiLogo className="size-full text-black" />}
        isOpen={isFarmDialogOpen}
        onOpenChange={setIsFarmDialogOpen}
      >
        <DetailsWasabiContent />
      </DetailsDialog>
    </div>
  );
};
